export default __webpack_public_path__ + "static/media/CREOS_BRIDE_120X278_01_265.ac9f74fb.jpg";